var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.999 18.191a6.662 6.662 0 006.666-6.658A6.662 6.662 0 0020 4.875a6.662 6.662 0 00-6.667 6.658 6.662 6.662 0 006.667 6.658z",
    stroke: "#000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.018 35.074a2.157 2.157 0 002.017-1.414c.1-.275.144-.567.127-.859-.256-4.363-1.02-6.074-2.305-7.357-3.215-3.21-22.5-3.21-25.714 0-1.285 1.283-2.05 2.994-2.305 7.357a2.147 2.147 0 002.144 2.273h26.036z",
    stroke: "#000",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.943 23.507l5.787 5.78 5.477-5.47M20.73 29.286v5.645",
    stroke: "#000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgUser;